import { Routes } from '@angular/router';
import { AuthGuard } from '@infodocs/shared/guards/auth.guard';

export const transactionRoutes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: ':transactionId',
        loadComponent: () => import('./pages/shared-form-page/shared-form-page.component').then(m => m.SharedFormPageComponent),
        children: [
          {
            path: 'file-beneficial-ownership',
            loadComponent: () => import('./pages/forms/file-beneficial-ownership-form/file-beneficial-ownership-form.component')
              .then(m => m.FileBeneficialOwnershipFormComponent),
          },
          {
            path: 'director-change',
            loadComponent: () => import('./pages/forms/director-change-form/director-change-form.component')
              .then(m => m.DirectorChangeFormComponent),
          },
          {
            path: 'file-company-reinstatement',
            loadComponent: () => import('./pages/forms/file-company-reinstatement-form/file-company-reinstatement-form.component')
              .then(m => m.FileCompanyReinstatementFormComponent),
          },
        ],
      },
    ],
  },
];
